import {TOOLTIP_SECTIONS} from './commons/constants';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import './PropertyEstimateTooltip.scss';
import xss from 'xss';
import PropertyEstimateTooltip from './PropertyEstimateTooltip.lazy';

const mapStateToProps = (state, ownProps) => {
  const rawDisclaimer = state.disclaimers.estimateTooltip;
  // Do we really need to send over HTML just to set breaks?
  const disclaimer = xss(rawDisclaimer);

  return {
    ...ownProps,
    disclaimer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
  };
};

const PropertyEstimateTooltipContainer = connect(mapStateToProps, mapDispatchToProps, mergeProps)(PropertyEstimateTooltip);

export { PropertyEstimateTooltipContainer, PropertyEstimateTooltip };

PropertyEstimateTooltipContainer.propTypes = {
  avm: PropTypes.shape({
    estimate: PropTypes.number,
    lowEstimate: PropTypes.number,
    highEstimate: PropTypes.number,
    fsd: PropTypes.number,
    clapiConfidence: PropTypes.oneOf([
      'NONE',
      'LOW',
      'MEDIUM_LOW',
      'MEDIUM',
      'MEDIUM_HIGH',
      'HIGH',
    ]),
    confidence: PropTypes.string,
    source: PropTypes.string,
  }),
  section: PropTypes.oneOf(TOOLTIP_SECTIONS),
  onCopyToReport: PropTypes.func,
};
export default PropertyEstimateTooltipContainer;